import { render, staticRenderFns } from "./WrapMaterialTable.vue?vue&type=template&id=6ab39b4e&scoped=true&lang=html&"
import script from "./WrapMaterialTable.vue?vue&type=script&lang=js&"
export * from "./WrapMaterialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab39b4e",
  null
  
)

export default component.exports